var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/context/PersonalizationProvider.tsx
import React, { useMemo } from "react";
import {
  PersonalizationContext
} from "@contensis/personalization";

// src/context/PersonalizationReactContext.tsx
import { createContext } from "react";
var PersonalizationReactContext = createContext(void 0);

// src/context/PersonalizationProvider.tsx
var GLOBAL = "CONTENSIS_PERSONALIZATION";
var PersonalizationProvider = (props) => {
  const currentContext = useMemo(() => {
    if ("context" in props && props.context) {
      return props.context;
    } else {
      const g = globalThis[GLOBAL] = typeof globalThis[GLOBAL] === "object" ? globalThis[GLOBAL] : {};
      const client = "alias" in props && props.alias || "rootUrl" in props && props.rootUrl ? {
        alias: props.alias,
        rootUrl: props.rootUrl,
        projectId: props.projectId,
        token: props.token || g.token
      } : void 0;
      const manifest = "manifest" in props && props.manifest ? props.manifest : void 0;
      const context = g.context = g.context || new PersonalizationContext({
        client,
        debug: props.debug,
        manifest,
        handlers: {
          onComputed: props.onComputed,
          onInit: props.onInit,
          onManifestReady: props.onManifestReady,
          onNavigate: props.onNavigate,
          onPageView: props.onPageView
        },
        session: props.session || void 0,
        preview: props.preview
      });
      return context;
    }
  }, []);
  const { children } = props;
  return /* @__PURE__ */ React.createElement(PersonalizationReactContext.Provider, { value: currentContext }, children);
};

// src/components/Experiment.tsx
import React2, { useEffect as useEffect2, useState as useState2 } from "react";

// src/hooks/usePersonalizationContext.tsx
import { useContext, useEffect, useState } from "react";
var usePersonalizationContext = () => {
  const context = useContext(PersonalizationReactContext);
  const [state, setState] = useState({
    audiences: [],
    signals: [],
    context,
    computed: [],
    isAudience: () => false,
    matched: [],
    pageViews: {
      session: 0,
      total: 0
    },
    percentile: 0,
    setAttributes: () => {
    },
    getAttributes: () => null,
    overrideAttributes: () => {
    },
    toggleAudience: () => {
    },
    t: 0
  });
  const updateState = () => {
    var _a, _b, _c, _d;
    if (context) {
      const {
        getAttributes,
        manifest,
        overrideAttributes,
        percentile,
        session,
        setAttributes,
        state: state2,
        t
      } = context;
      const audiences = ((_a = state2.audiences) == null ? void 0 : _a.active) || [];
      const signals = ((_b = state2.signals) == null ? void 0 : _b.active) || [];
      setState({
        audiences,
        signals,
        computed: ((_c = context.signals) == null ? void 0 : _c.computed) || [],
        context,
        getAttributes,
        isAudience: (id) => Array.isArray(id) ? id.some((item) => audiences.includes(item)) : audiences.includes(id),
        matched: ((_d = context.signals) == null ? void 0 : _d.matched) || [],
        manifest,
        overrideAttributes,
        pageViews: {
          session: session.state.pageViews,
          total: state2.pageViews
        },
        percentile,
        setAttributes,
        state: state2,
        toggleAudience: context.toggleAudience,
        t
      });
    }
  };
  useEffect(() => {
    const computedHandler = context == null ? void 0 : context.addHandler("onComputed", () => {
      updateState();
    });
    const manifestHandler = context == null ? void 0 : context.addHandler("onManifestReady", () => {
      updateState();
    });
    return () => {
      if (computedHandler)
        context == null ? void 0 : context.removeHandler("onComputed", computedHandler);
      if (manifestHandler)
        context == null ? void 0 : context.removeHandler("onManifestReady", manifestHandler);
    };
  }, []);
  useEffect(() => {
    updateState();
  }, [context == null ? void 0 : context.pageViews.length, context == null ? void 0 : context.t]);
  if (!context) {
    throw new Error(
      "usePersonalizationContext must be used within a <PersonalizationContext> provider"
    );
  }
  return state;
};

// src/components/Experiment.tsx
var DEFAULT_SPLIT_KEY = "split";
var Experiment = (props) => {
  const Component = "children" in props ? props.children : "render" in props ? props.render : null;
  const { percentile } = usePersonalizationContext();
  const [split] = useState2(
    props.splitKey || DEFAULT_SPLIT_KEY
  );
  const [sorted] = useState2(
    props.experiments.sort((e) => Number(e[split])).reverse()
  );
  const [variant, setVariant] = useState2(sorted.find((e) => !e[split]));
  useEffect2(() => {
    for (const experiment of sorted) {
      if (percentile >= Number(experiment[split])) {
        setVariant(experiment);
        break;
      }
    }
  }, [percentile, sorted, split]);
  if (Component && variant) {
    return /* @__PURE__ */ React2.createElement(Component, __spreadValues({}, variant));
  }
  return null;
};

// src/components/Personalize.tsx
import React3, { useEffect as useEffect3, useState as useState3 } from "react";
var DEFAULT_AUDIENCE_KEY = "audiences";
var Personalize = (_a) => {
  var _b = _a, {
    audienceKey = DEFAULT_AUDIENCE_KEY
  } = _b, props = __objRest(_b, [
    "audienceKey"
  ]);
  var _a2;
  const Component = "children" in props ? props.children : "render" in props ? props.render : null;
  const { isAudience } = usePersonalizationContext();
  const [audiences] = useState3(audienceKey);
  const [defaultContent] = useState3(
    props.defaultContent || ((_a2 = props.variants) == null ? void 0 : _a2.find(
      (variant) => audiences in variant && !variant[audiences] || Array.isArray(variant[audiences]) && !variant[audiences].length
    )) || null
  );
  const [personalizedVariant, setPersonalizedVariant] = useState3(null);
  useEffect3(() => {
    let personalized = false;
    for (const variant of props.variants) {
      if (isAudience(variant[audiences])) {
        setPersonalizedVariant(variant);
        personalized = true;
        break;
      }
    }
    if (!personalized) setPersonalizedVariant(defaultContent);
  }, [audiences, defaultContent, isAudience]);
  if (Component && personalizedVariant) {
    return /* @__PURE__ */ React3.createElement(Component, __spreadValues({}, personalizedVariant));
  }
  return null;
};
export {
  Experiment,
  PersonalizationProvider,
  Personalize,
  usePersonalizationContext
};
//# sourceMappingURL=personalization-react.mjs.map